import { TableWithStoredSettingsAndLayoutSettings } from '@Components/Tables/TableWithStoredSettingsAndLayoutSettings';
import { PERMISSIONS_API } from '@Constants/backendConstants';
import { mandantColumns } from '@Constants/TableColumns';
import type { ApiMandant } from '@Model';
import { EnumFrontendLayoutSetting } from '@Model';
import { useListApi } from '@Hooks/useListApi';
import { MandantenRepository } from '@Repositories/Permissions';

export function FrameListMandant() {
    const module = useListApi(MandantenRepository, PERMISSIONS_API);

    return (
        <TableWithStoredSettingsAndLayoutSettings<ApiMandant>
            layoutSettingsContext={EnumFrontendLayoutSetting.MandantsTableLayout}
            name="MandantList"
            columns={mandantColumns}
            loader={module.loadPage}
            canCreate={false}
            useOnClickNavigation
            fullSize
        />
    );
}
